import React, { Component } from 'react';
import './style.css';
import Col from 'react-bootstrap/Col';
import Button from '../Button/Button';
import { withRouter } from 'react-router-dom';
import businessBanner from 'Assets/storyimg.png';
class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let guestHomeHead = {};
    // eslint-disable-next-line
    if (this.props.bannerImg) {
      guestHomeHead['backgroundImage'] = `url( ${this.props.bannerImg})`;
    } else {
      guestHomeHead['backgroundImage'] = `url(${businessBanner})`;
    }
    if (this.props.bannerHeight) {
      guestHomeHead.height = this.props.bannerHeight;
    }
    return (
      <div>
        <section className="schoolhome-head" style={guestHomeHead}>
          <div className="schoolhome-overlay">
            <div className="container">
              <div className="row">
                <Col sm={12} md={9} lg={7}>
                  {
                    this.props.btnStatus !== false ?
                      <div className="banner-btn">
                        <h1>{this.props.BannerHead}</h1>
                        <div className="">
                          <p>{this.props.BannerSubHead}</p>
                        </div>
                        <div className="press-mail">
                          <a href="mailto:support@pechakucha.org">{this.props.pressEmail}</a>
                        </div>
                        <div className="creativeGameBanner">
                          <h1>{this.props.upcomingGames}</h1>
                          <h6>{this.props.presentedBy}</h6>
                          <p>{this.props.dateOfPresentation}</p>
                        </div>
                        <a rel="noopener" target={this.props.link_out ? '_blank' : ''} href={this.props.link_out || this.props.typeForm} className="btn-start-color">
                        <Button theme="btn-getstarted btn-hover btn-green btn-fit btn-none">
                          {this.props.btnText}
                        </Button>
                        </a>
                      </div>
                      : null
                  }
                  <div className="internationalBanner internationalbanner-btn">
                    <h1>{this.props.internationalDay}</h1>
                    <h1>{this.props.internationalEvents}</h1>
                    <h1>{this.props.internationalPresentations}</h1>
                  </div>
                </Col>

                <Col lg={5}>
                  <div className="banner-background">

                  </div>
                </Col>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}


export default withRouter(Banner);